import { Outlet } from 'react-router-dom';

export const AuthLayout = () => (
  <main className="grid min-h-screen place-items-center bg-shell px-4 py-10 text-white">
    <Outlet />
  </main>
);
